import { FC, MouseEvent, useState } from "react"
import { useTranslation } from "react-i18next"

import { Guid } from "@/types"
import AssetFeaturesModal from "components/AssetFeaturesModal/AssetFeaturesModal"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"

interface IShowFeaturesButtonProps {
    assetId: Guid
    onOpen?: () => void
    onClose?: () => void
}

const ShowFeaturesButton: FC<IShowFeaturesButtonProps> = ({
    assetId,
    onOpen,
    onClose,
}) => {
    const { t } = useTranslation()
    const [showFeaturesModal, setShowFeaturesModal] = useState(false)

    function handleShowFeaturesClick(e: MouseEvent) {
        e.stopPropagation()
        e.preventDefault()
        setShowFeaturesModal(true)
        onOpen?.()
    }

    function handleCloseFeaturesModal() {
        setShowFeaturesModal(false)
        onClose?.()
    }

    return (
        <>
            <button className="link color-brand-blue"
                onClick={handleShowFeaturesClick}>
                <FlexibleContent text={t('asset.showFeatures')} />
            </button>
            {showFeaturesModal &&
                <AssetFeaturesModal
                    assetId={assetId}
                    onClose={handleCloseFeaturesModal}
                />
            }
        </>
    )
}

export default ShowFeaturesButton
